<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_item_category") }}
      </h1>
    </div>

    <!-- Add Category Form Section -->
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700"
      v-if="
        $store.getters['checkUserAccess']({
          id: '3',
          action: 'add',
        })
      "
    >
      <div class="">
        <form @submit="addSaleItem">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
          <BaseInput
            v-model="ca_name"
            :label="$t('item_category_name')"
            :placeholder="$t('item_category_name')"
            :rules="rules"
            :isError="checkRulesIsError(ca_name, 'add').isError"
            :errorMsg="checkRulesIsError(ca_name, 'add').errorMsg"
          />
          </div>

          <ButtonInput
            type="button"
            @click="addSaleItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <div
    class="w-full"
    id="printDev"
    v-if="
      $store.getters['checkUserAccess']({
        id: '3',
        action: 'view',
      })
    "
  >
    <div
      :class="
        ' mx-2 mt-14 mb-5 p-3 h-full bg-slate-100 dark:bg-bgFullDark rounded-2xl ' +
        ($store.getters['isRtl']
          ? ' md:mr-60 '
          : ' md:ml-60  ')
      "
    >
      <div class="my-2 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl">
      <div class="relative overflow-x-auto mt-4 mb-6">
        <div class="flex items-center justify-between pb-4 mx-5 no-print">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.item_category.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            />
          </div>
        </div>
        <!--in ltr change (text-right to text-left)-->
        <EasyDataTable
          :headers="headers"
          :items="filterItems"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :alternating="false"
          :buttons-pagination="true"
          :loading="isLoadingData"
          :table-class-name="isDark ? 'modern-dark-table mx-6' : 'mx-6'"
        >
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <button
              class="mx-1 my-1"
              @click="showModal(item)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '3',
                  action: 'edit',
                })
              "
            >
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button
              class="mx-1 my-1"
              @click="deleteItem(item.ca_id)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '3',
                  action: 'delete',
                })
              "
            >
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
          </template>

          <template #item-ca_show="item">
            <span
              class="text-green-500 dark:text-white"
              v-if="item.ca_show == 1"
              >{{ $t("show") }}</span
            >
            <span
              class="text-red-500 dark:text-white"
              v-else-if="item.ca_show == 0"
              >{{ $t("hide") }}</span
            >
          </template>
          <template #loading>
            <div class="flex items-center justify-center py-8">
              <img
                src="../../assets/loading.webp"
                class="w-16 h-16 animate-pulse"
                alt="Loading..."
              />
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }} </template
          >
          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12 text-gray-500 dark:text-gray-400">
              <i class="fa-solid fa-inbox text-4xl mb-4"></i>
              <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
            </div>
          </template>
          <template
            #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
          >
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.ca_name"
          :label="$t('item_category_name')"
          :placeholder="$t('item_category_name')"
          :rules="rules"
          :isError="checkRulesIsError(current.ca_name, 'edit').isError"
          :errorMsg="checkRulesIsError(current.ca_name, 'edit').errorMsg"
        />
    
        <BaseInput
          v-model="current.ca_show"
          :label="$t('show')"
          :placeholder="$t('show')"
          :rules="rules"
          :isError="checkRulesIsError(current.ca_show, 'edit').isError"
          :errorMsg="checkRulesIsError(current.ca_show, 'edit').errorMsg"
        />
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import "../../assets/css/modern-table.css";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      ca_name: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
    };
  },
  created() {
    if (
      this.$store.getters["checkUserAccess"]({
        id: "3",
        action: "view",
      })
    ) {
      this.getData();
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.item_category.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.item_category.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("item_category/SET_DELETE_SUCCESS", false);
      }
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.item_category.isShowResultDialog;
    },
    items() {
      return this.$store.state.item_category.items;
    },
    filterItems() {
      return this.$store.getters["item_category/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.item_category.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.item_category.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.item_category.isBtnEditLoading;
    },
    headers() {
      return [
        { text: "#", value: "ca_id", sortable: true },
        {
          text: this.$t("item_category_name"),
          value: "ca_name",
          sortable: true,
        },
        {
          text: this.$t("show"),
          value: "ca_show",
          sortable: true,
        },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
    },
  },

  methods: {
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      this.$store.dispatch("item_category/getItems");
    },
    handleSearchInput(value) {
      this.$store.commit('item_category/SET_SEARCH', value);
    },
    async addSaleItem(e) {
      e.preventDefault();
      //check form validation
      if (this.$store.state.item_category.isBtnLoading) return;

      this.isSubmited = true;
      if (this.checkRulesIsError(this.ca_name, "add").isError) {
        return;
      }
      this.$store.state.item_category.isBtnLoading = true;
      var res = await this.$store.dispatch(
        "item_category/addNewItem",
        this.ca_name
      );
      if (res.status == 200) {
        this.ca_name = "";
        this.isSubmited = false;
        this.$store.state.item_category.isBtnLoading = false;
      }
      this.isSubmited = false;
    },
    checkRulesIsError(value, type) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of this.rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("item_category/REMOVE_ITEM", id);
        this.$store.dispatch("item_category/deleteItem", id);
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.ca_name, "edit").isError ||
        this.checkRulesIsError(this.current.ca_show, "edit").isError
      ) {
        return;
      }
     
      this.$store.state.item_category.isBtnEditLoading = true;
      var res = await this.$store.dispatch("item_category/editItem", {
        ca_id: this.current.ca_id,
        ca_name: this.current.ca_name,
        ca_show: this.current.ca_show,
      });

      this.isSubmitedEdit = false;
      this.$store.state.item_category.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
      }
    },
  },
};
</script>
